import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PITIPageComponent } from './piti.page';

const routes: Routes = [
  {
    component: PITIPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PITIPageRoutingModule {}
